import React, { lazy, Suspense } from "react";
const LazyCreateProject = lazy(() => import("./CreateProject"));
const LazyRePrintShuqaApartment = lazy(() => import("./RePrintShuqaApartment"));
const LazyReProjectListing = lazy(() => import("./ReProjectListing"));
const LazyReViewProject = lazy(() => import("./ReViewProject"));
const LazyBillListingProject = lazy(() =>
  import("./ProjectBill/BillListingProject")
);
const LazyListAllprojectBills = lazy(() =>
  import("./ProjectBill/ListAllprojectBills")
);
const LazyPrintAllProjects = lazy(() =>
  import("./ProjectBill/PrintAllProjects")
);
const LazyPrintListOfProjectBills = lazy(() =>
  import("./ProjectBill/PrintListOfProjectBills")
);
const LazyPrintSupport = lazy(() => import("./ProjectBill/PrintSupport"));
export const PrintSupport = () => (
  <Suspense fallback="loading...">
    <LazyPrintSupport />
  </Suspense>
);
export const PrintListOfProjectBills = () => (
  <Suspense fallback="loading...">
    <LazyPrintListOfProjectBills />
  </Suspense>
);
export const BillListingProject = () => (
  <Suspense fallback="loading...">
    <LazyBillListingProject />
  </Suspense>
);
export const ListAllprojectBills = () => (
  <Suspense fallback="loading...">
    <LazyListAllprojectBills />
  </Suspense>
);
export const PrintAllProjects = () => (
  <Suspense fallback="loading...">
    <LazyPrintAllProjects />
  </Suspense>
);
export const CreateProject = () => (
  <Suspense fallback="loading...">
    <LazyCreateProject />
  </Suspense>
);
export const RePrintShuqaApartment = () => (
  <Suspense fallback="loading...">
    <LazyRePrintShuqaApartment />
  </Suspense>
);
export const ReProjectListing = () => (
  <Suspense fallback="loading...">
    <LazyReProjectListing />
  </Suspense>
);
export const ReViewProject = () => (
  <Suspense fallback="loading...">
    <LazyReViewProject />
  </Suspense>
);
